import type * as React from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';

// shadcn/ui (AD #39): shadcn's Sonner toaster, adapted to the CRM's rules (design-system §5 Toast, Rev 58).
//   - It looks like `src/ui`'s Toast: bottom-centre, the deep-green toast fill with its paired text, and
//     `radius/md`, through Sonner's own colour variables. shadcn's version reads the theme from
//     `next-themes`, which this app does not use; the CRM's tokens already follow the theme.
//   - It is mounted once, at the app root (`main.tsx`), so every screen's `toast()` lands in one region.
//   - Announcements: Sonner's region (`<section aria-live="polite">`) is rendered from the first paint,
//     before any toast, so a toast's text is announced when it arrives — the rule `src/ui`'s Toast
//     documents (a live region must exist before its content does).
//   - A toast with an action (*Undo*) is raised with `duration: Infinity` and a *Dismiss* `cancel`
//     button by its caller, so it stays until it is acted on or closed (WCAG 2.2.1).
//   - Its buttons are at least the 24px target-size floor (WCAG 2.2 SC 2.5.8): Sonner draws them 24px
//     tall, and `buttonStyle` sets the floor explicitly (`space/7` is 24px) in case a later version
//     shrinks them.

const buttonStyle: React.CSSProperties = {
    minBlockSize: 'var(--et-space-7)',
    paddingInline: 'var(--et-space-3)',
};

function Toaster(props: React.ComponentProps<typeof SonnerToaster>) {
    return (
        <SonnerToaster
            position="bottom-center"
            style={
                {
                    '--normal-bg': 'var(--et-brand-deep-green-bg)',
                    '--normal-text': 'var(--et-brand-deep-green-on)',
                    '--normal-border': 'var(--et-brand-deep-green-bg)',
                    '--border-radius': 'var(--et-radius-md)',
                } as React.CSSProperties
            }
            toastOptions={{ actionButtonStyle: buttonStyle, cancelButtonStyle: buttonStyle }}
            {...props}
        />
    );
}

export { Toaster, toast };
